var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { ItemModalStyled, BasicModalStyled, CenterModalBody, ExitButtonStyled, ConfirmButtonWrapperStyled, } from './styled';
import Icon from '../Icon';
import IconButton from '../IconButton';
import { TucarTheme } from '../theme';
import Typography from '../Typography';
import Button from '../Button';
const Modal = (_a) => {
    var { children, onClose, onConfirm, open } = _a, props = __rest(_a, ["children", "onClose", "onConfirm", "open"]);
    const { hideBackdrop, title, type, variant, ubication, style, confirmationMode } = props, rest = __rest(props, ["hideBackdrop", "title", "type", "variant", "ubication", "style", "confirmationMode"]);
    const iconAlert = () => {
        switch (type) {
            case 'success':
                return { name: 'checkCircleRounded', color: TucarTheme.colors.green600 };
            case 'informative':
                return { name: 'addAlertFilled', color: TucarTheme.colors.blue500 };
            case 'error':
                return { name: 'errorRounded', color: TucarTheme.colors.error500 };
            default:
                return { name: 'warningRounded', color: TucarTheme.colors.warning600 };
        }
    };
    const titleVariant = () => {
        const { color } = variant !== 'informative' ? iconAlert() : { color: TucarTheme.colors.blue500 };
        switch (variant) {
            case 'alert':
                return (_jsx(Typography, Object.assign({ variant: "p", color: color, weight: "medium" }, { children: title })));
            case 'informative':
                return (_jsx(Typography, Object.assign({ variant: "p", color: color, weight: "medium" }, { children: title })));
            case 'notification':
                return (_jsx(Typography, Object.assign({ style: { fontSize: '20px', lineHeight: 1.2, textAlign: 'left', width: '100%' }, variant: "h3", color: color, weight: "medium" }, { children: title })));
            default:
                return '';
        }
    };
    useEffect(() => {
        const body = document.querySelector('body');
        if (open) {
            body.style.overflow = 'hidden';
            body.style.pointerEvents = 'none';
        }
        else {
            body.style.overflow = 'auto';
            body.style.pointerEvents = 'auto';
        }
    }, [open]);
    if (variant === 'custom') {
        return (_jsx(BasicModalStyled, Object.assign({ hideBackdrop: hideBackdrop, style: style, ubication: ubication, open: open }, rest, { children: children })));
    }
    if (variant === 'informative') {
        return (_jsx(BasicModalStyled, Object.assign({ hideBackdrop: hideBackdrop, variant: variant, style: style, ubication: ubication, open: open }, rest, { children: _jsxs(CenterModalBody, { children: [title && titleVariant(), children, onConfirm && _jsx(Button, Object.assign({ onClick: onConfirm }, { children: "Aceptar" }))] }) })));
    }
    if (variant === 'alert' && confirmationMode) {
        return (_jsx(BasicModalStyled, Object.assign({ hideBackdrop: hideBackdrop, variant: variant, style: style, ubication: ubication, open: open }, rest, { children: _jsxs(CenterModalBody, { children: [_jsxs("div", Object.assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(ItemModalStyled, Object.assign({ type: type }, { children: _jsx(Icon, Object.assign({}, iconAlert())) })), title && titleVariant()] })), children, _jsxs(ConfirmButtonWrapperStyled, Object.assign({ style: { display: 'flex', alignItems: 'center', gap: '10px' } }, { children: [_jsx(Button, Object.assign({ variant: "ghost", onClick: onClose }, { children: "Cancelar" })), _jsx(Button, Object.assign({ onClick: onConfirm }, { children: "Aceptar" }))] }))] }) })));
    }
    if (variant === 'alert' && !confirmationMode) {
        return (_jsx(BasicModalStyled, Object.assign({ hideBackdrop: hideBackdrop, variant: variant, style: style, ubication: ubication, open: open }, rest, { children: _jsxs(ExitButtonStyled, Object.assign({ variant: variant }, { children: [_jsx(ItemModalStyled, Object.assign({ type: type }, { children: _jsx(Icon, Object.assign({}, iconAlert())) })), _jsxs("div", Object.assign({ style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'start',
                            textAlign: 'start',
                        } }, { children: [title && titleVariant(), children] })), _jsx(IconButton, { "data-testid": "clearButtonModal", onClick: onClose, variant: "ghost", iconProps: { name: 'clearRounded', color: '#17171C', size: '24px' } })] })) })));
    }
    return (_jsx(BasicModalStyled, Object.assign({ hideBackdrop: hideBackdrop || true, variant: variant, style: style, ubication: ubication, open: open }, rest, { children: _jsxs(ExitButtonStyled, Object.assign({ variant: variant }, { children: [_jsx(ItemModalStyled, Object.assign({ type: type }, { children: _jsx(Icon, Object.assign({}, iconAlert())) })), _jsxs("div", Object.assign({ style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'start',
                        width: '100%',
                        height: '100%',
                        justifyContent: children ? 'start' : 'center',
                    } }, { children: [title && titleVariant(), children] })), _jsx(IconButton, { "data-testid": "clearButtonModal", onClick: onClose, variant: "ghost", iconProps: { name: 'clearRounded', color: '#17171C', size: '24px' } })] })) })));
};
Modal.defaultProps = {
    variant: 'custom',
    type: 'informative',
    title: '',
    ubication: 'center',
    children: null,
};
export default Modal;
//# sourceMappingURL=index.js.map